import MUIDrawer from '@mui/material/Drawer';
import {styled} from '@mui/material/styles';
import React from 'react';

import dimensions from '@app/styles/dimensions';

export const Drawer = styled(MUIDrawer)(({theme}) => ({
  width: dimensions.leftSidebar.width,
  '& .MuiDrawer-paper': {
    position: 'absolute',
    overflow: 'visible',
  },
  '& .MuiDrawer-paperAnchorLeft': {
    width: dimensions.leftSidebar.width,
  },
  '& .MuiDrawer-paperAnchorRight': {
    width: dimensions.rightSidebar.width,
    backgroundColor: theme.palette.grey[800],
  },
}));

export const LeftDrawer = props => (
  <Drawer anchor="left" variant="persistent" {...props} />
);

export const RightDrawer = props => (
  <Drawer
    anchor="right"
    variant="persistent"
    className="pl-mode-dark"
    {...props}
  />
);

export const LeftTemporaryDrawer = props => {
  // props get injected on mount and this is the only way to update modal style
  const ModalProps = {
    keepMounted: true,
    sx: {
      zIndex: 'drawer',
      top: dimensions.topNav.height,
      left: dimensions.sideNav.width,
    },
    BackdropProps: {
      sx: {
        top: dimensions.topNav.height,
        left: dimensions.sideNav.width,
      },
    },
  };

  return (
    <Drawer anchor="left" elevation={0} ModalProps={ModalProps} {...props} />
  );
};
